    import PDFJS from 'pdfjs-dist'
    export default {
        data() {
            return {
                pdfDoc: null,
                //可以打印发现是一个对象，里面有页数信息等
                pageNum: 1,
                pageNumPending: null,
                url: '',
                loading: ''
            }
        },
        methods: {
            print() {
                window.print();
            },
            download() {
                location.href = this.url
            },
            getPdf() {
                this.$http.get(globalProvider.serviceUrl('eam_exm_ct/gct/{id}/{batch_id}/{sd}'), {
                    params: {
                        id: this.$route.query.regId,
                        batch_id: this.$route.query.batch_id,
                        sd: this.$route.query.sd
                    }
                }).then((data) => {
                    if (data.body.code == resultCode.Success) {
                        this.url = data.body.data;
                        this.showPDF(data.body.data);
                    } else if (data.body.code == resultCode.NotSuccess) {
                        this.$alert(getErrorMessage(data.body.message), '提示', {
                            confirmButtonText: '确定'
                        });
                    }
                });
            },
            showPDF(url) {
                let _this = this;
                PDFJS.getDocument(url).then(function (pdf) {
                    _this.pdfDoc = pdf;
                    _this.renderPage(1)
                })
            },
            renderPage(num) {
                this.pageRendering = true;
                this.pdfDoc.getPage(num).then(function (page) {
                    var viewport = page.getViewport(5);
                    let canvas = document.getElementById('the-canvas');
                    canvas.height = viewport.height;
                    canvas.width = viewport.width;
                    // Render PDF page into canvas context
                    var renderContext = {
                        canvasContext: canvas.getContext('2d'),
                        viewport: viewport
                    };
                    page.render(renderContext);
                })
                setTimeout(() => {
                    this.loading.close();
                }, 2000);
            },
            queueRenderPage(num) {
                if (this.pageRendering) {
                    this.pageNumPending = num
                } else {
                    this.renderPage(num)
                }
            },
            onPrevPage() {
                if (this.pageNum <= 1) {
                    return
                }
                this.pageNum--;
                this.queueRenderPage(this.pageNum)
            },
            onNextPage() {
                if (this.pageNum >= this.pdfDoc.numPages) {
                    return
                }
                this.pageNum++;
                this.queueRenderPage(this.pageNum)
            }
        },
        created() {
            this.loading = this.$loading({
                lock: true,
                text: '加载中',
                background: '#fff'
            });
            this.getPdf()
        },
    }